import { useQuery } from '@tanstack/react-query'
import { getAirportLocations } from '~/services/locationService'
import { GenericClientError } from '~/utils/errors'
import { useNotification } from '~/context/notification'
import { useEffect } from 'react'

type QueryOptions = {
  partnerId: string
  enabled: boolean
  originAirport?: string
}

export function useQueryAirportsList({ partnerId, originAirport, enabled = true }: QueryOptions) {
  const { addErrorCodeNotification } = useNotification()

  const { data, error, isError, isFetching } = useQuery({
    queryKey: ['airports', partnerId, originAirport],
    queryFn: async () => {
      const results = await getAirportLocations({ partnerId, fromAirport: originAirport })
      results.sort((airportA, airportB) => airportA.airportName.localeCompare(airportB.airportName))
      return results
    },
    enabled,
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('FLIGHTS_LOCATIONS_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  return { data, isFetching }
}
